import { useOktaAuth } from '@okta/okta-react'
import React, { useEffect, useState} from 'react'
import { useUserInfo } from '../../providers/userProvider'
import { getCampaigsByRn } from '../../services/campaign.service';
import queryString from 'query-string'
import { ERR_DESC_REQUEST_NUMBER, ERR_DESC_SURVEY_CODE, ERR_TITLE_REQUEST_NUMBER, ERR_TITLE_SURVEY_CODE} from '../../utils/errorLiterals';
import { SCBM_USER_TYPE, TPS, TPSMEX} from '../../utils/surveyLiterals';
import { Redirect } from 'react-router-dom';
import { getSurveyById } from '../../services/survey.service';
import { TPSSurveyPage } from './TPSSurveyPage';
import cookie from 'js-cookie'
import { getSuppSurveyConfiguration } from '../../services/userService';
import {DEFAULT_LANGUAGE} from '../../utils/surveyLiterals';

function isValidRN(rn) {
  return rn && rn.length <= 19 && !isNaN(rn) && Number.isInteger(parseFloat(rn));//Size in DB
}

function validationRules(respCampaign, userInfo) {
  let error;
  if (respCampaign) {
      let campaign = respCampaign;
      if (userInfo.userType !== SCBM_USER_TYPE.SALARY) {
          //it is normal user, we have to validate that the current user has the supplier
          if (!userInfo.suppliers || userInfo.suppliers.length <= 0
              || !userInfo.suppliers.includes(campaign.assignments[0].supplierNumber)) {
              error = 'No suppliers assigned';
          }//else everything is OK
      }//else Read only for the deere employee
  } else {//The assignment does not exist
      error = 'No campaing found';
  }
  return error;
}


export default function Home({...props}){
    const actualURL = window.location.href;
    const { authState } = useOktaAuth();
    const userInfo = useUserInfo();
    const [campaignAssigned, setCampaignAssigned] = useState();
    const [containsError, setContainsError] = useState(false);
    const [survey, setSurvey] = useState(undefined);
    const [currentLanguageCode] = useState(cookie.get('i18next') || DEFAULT_LANGUAGE);

    let value = queryString.parse(props.location.search);
    const rn = value.rn;

    useEffect(() => {
        if (userInfo && rn && !campaignAssigned && isValidRN(rn)) {
            getCampaigsByRn(rn, authState.accessToken.accessToken)
                .then((res) => {
                    let errorValidation = validationRules(res, userInfo);
                    if (errorValidation) {
                        console.log(errorValidation);
                        setContainsError(true)
                    } else {
                        setCampaignAssigned(res);
                    }
                }).catch(error => {
                    //Campaign not found
                    console.log(error);
                    setContainsError(true)
                })
        }
    }, [userInfo, campaignAssigned]);

    useEffect(() => {
      if (!survey && campaignAssigned && !containsError) {
          if(currentLanguageCode !== DEFAULT_LANGUAGE){
            getSuppSurveyConfiguration(campaignAssigned.surveyId, currentLanguageCode, authState.accessToken.accessToken)
            .then((s) => {
                setSurvey(s);
    })
          }
          else{
            getSurveyById(campaignAssigned.surveyId, authState.accessToken.accessToken)
              .then((s) => {
                  setSurvey(s);
              })
          }
      }
    }, [survey, campaignAssigned])

    if (!rn || containsError || !isValidRN(rn)) {
      return <Redirect
              to={{
              pathname: '/error',
              state: {errorTitle: ERR_TITLE_REQUEST_NUMBER,
                      errorDescription: ERR_DESC_REQUEST_NUMBER,
                      errorUrl:actualURL,
                      errorUser: userInfo? userInfo.userID : ''}
              }}
          />
  }
  if (!userInfo || !campaignAssigned  || !survey) {
      return (<div>
          <h5>Loading...</h5>
      </div>)
  } else {
      switch(survey.code){
        case TPS:
        case TPSMEX:
            return <TPSSurveyPage survey={survey} campaignAssigned={campaignAssigned} setSurvey={setSurvey}/>
          default:
              return <Redirect
                          to={{
                          pathname: '/error',
                          state: {errorTitle: ERR_TITLE_SURVEY_CODE,
                                  errorDescription: ERR_DESC_SURVEY_CODE,
                                  errorUrl:actualURL,
                                  errorUser: userInfo? userInfo.userID : ''}
                          }}
                      />
      }
  }

}
